import React from 'react'

import Title from '@/components/Form/Title'

type CardProps = {
  title?: string
  children?: React.ReactNode
}

const Card = ({ title, children }: CardProps) => (
  <div className="card flex w-full flex-1 flex-col gap-4 border bg-zinc-50 px-6 py-8">
    {title && <Title title={title} />}
    {children}
  </div>
)

export default Card
